// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1FfHV","main-image":"Header_main-image__398p6"};